<script>

export default {

    data() {
        return {
            date: null,
            saved: false,
            errors: {},
            loading: false,
            data: {
                name: null
            },
            controller: null,
        }
    },

    methods: {
        save() {
            this.loading = true;
            this.controller = new AbortController();

            let data = new FormData();

            data.append('name', this.data.name);

            axios.post('training-categories',
                data, {
                    signal: this.controller.signal
                }).then(() => {
                this.saved = true;
                this.close();
            }).catch(data => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            })
        },

        close() {
            this.controller && this.controller.abort();
            this.$emit('close', {saved: this.saved});
        }
    }
};
</script>

<template>
    <section>
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ $t('training_categories.labels.new_category') }}
                    </p>
                    <button type="button" class="delete" aria-label="close" @click="close"></button>
                </header>
                <form @submit.prevent="save">
                    <section class="modal-card-body">

                        <b-field :label="$t('training_categories.fields.name.name')"
                                 custom-class="mb-3"
                                 label-for="name"
                                 :type="errors.name ? 'is-danger' : null"
                                 :message="errors.name ? errors.name[0] : null">
                            <b-input
                                required
                                v-model="data.name"
                            />
                        </b-field>

                    </section>
                    <footer class="modal-card-foot">
                        <div class="buttons">
                            <b-button native-type="submit"
                                      :disabled="loading"
                                      :loading="loading"
                                      type="is-success">
                                {{ $t('actions.save')}}
                            </b-button>
                            <b-button @click.prevent="close">
                                {{ $t('actions.cancel')}}
                            </b-button>
                        </div>
                    </footer>
                </form>
            </div>
        </div>
    </section>
</template>
